import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { configTagsList_template } from "../components/templates/configTagsList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class config_tags extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: configTagsList_template;
    protected pagination: pagination_template;

    protected getModuleName(){
        return "config_Tags";
    }

    buildContent() : Array<Element>{

        this.elementsList = new configTagsList_template( "configTags", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Config Tags");

        return [ this.elementsList.build()];
    }

    public fillPage() : void{

        this.filterList();
    }

    protected showTags() {

        this.filterList();
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));


        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/tags/get/";

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.elementsList.getViewModelForRequest();

        usrReq_params.push(["data", ko.toJSON(vm)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);


        this.XHRHdl.onReadyStateFunction = this.onGetTagsReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagsReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function() {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);

            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any){

        // set Jobs list
        let tagsToSet = [];
        for (let item of responseParsed.data) {
            tagsToSet.push( {

                id: item.id
                ,name: item.name
                ,slug : item.details ? item.details.slug : ''
                ,description : item.details ? item.details.description : ''
                ,isSelectable : item.details ? item.details.isSelectable : false
            } )
        }

        this.elementsList.setTags(tagsToSet);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.elementsList.pagination.setNumberItemToPaginate(responseParsed.totalCount);
    }

    protected tagListReorder() {

        this.filterList();
    }

    private resetPageNumber(){
        // go back to page 1 in the pagination
        this.elementsList.pagination.getTemplateViewModel().pageNumber(1);
    }

    // required from template [logsList_template]
    protected paginationOnPageClick(){
        this.filterList();
    }

    // required from template [logsList_template]
    protected filterSimpleOnChange(){
        this.resetPageNumber();
        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    protected viewTag(id){

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page('/brand/' + idBrand + '/categorization/tags/view/'+id);
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_tags.ts